import React, { useState } from 'react';

//Components
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';

// Styles
import styles from './index.module.sass';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction='down' ref={ref} {...props} />;
});

const Alert = (props) => {
  const [alertOpen, setAlertOpen] = useState(false);

  const {
    open = alertOpen,
    setOpen = setAlertOpen,
    title = '',
    text = '',
    callback,
    cancel = false,
    okText = 'Ok',
    cancelText = 'Cancel',
  } = props;

  const handleClose = () => {
    if (callback) callback();
    setOpen(false);
  };

  const handleCancel = () => {
    setOpen(false);
  };

  return (
    <Dialog
      open={open}
      TransitionComponent={Transition}
      keepMounted
      onClose={cancel ? handleCancel : handleClose}
      aria-labelledby='alert-dialog-slide-title'
      aria-describedby='alert-dialog-slide-description'>
      <div className={styles.container}>
        <DialogTitle id='alert-dialog-slide-title' className={styles.title}>
          {title}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id='alert-dialog-slide-description' className={styles.text}>
            {text}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          {cancel && (
            <Button onClick={handleCancel} className={styles.cancelButton} variant='contained'>
              {cancelText}
            </Button>
          )}
          <Button onClick={handleClose} className={styles.button} variant='contained'>
            {okText}
          </Button>
        </DialogActions>
      </div>
    </Dialog>
  );
};

export default Alert;
